<template>
  <div id="page">
    <NavBar />

    <main>
      <div class="sub_header_in sticky_header">
        <div class="container">
          <h1>{{ $t('lang.titles.bookings') }}</h1>
        </div>
      </div>

      <Errors :errors="errors" />
      <Success :success-message="successMessage" />

      <div
        v-if="showData"
        class="container margin_60_35"
      >
        <div class="row">
          <aside
            id="sidebar"
            class="col-lg-3 "
          >
            <div id="filters_col">
              <a
                id="filters_col_bt"
                class="bookings_aside"
                data-toggle="collapse"
                href="#collapseFilters"
                aria-expanded="false"
                aria-controls="collapseFilters"
              >{{ $t('lang.bookings.aside_title') }} </a>
              <div
                id="collapseFilters"
                class="collapse show bookings_aside"
              >
                <div class="filter_type">
                  <h6>{{ $tc('lang.bookings.aside_text', 1) }}</h6>
                  <p>{{ $tc('lang.bookings.aside_text', 2) }}</p>
                  <p>{{ $tc('lang.bookings.aside_text_1', 1) }}</p>
                  <p>{{ $tc('lang.bookings.aside_text_1', 2) }}</p>
                  <p>{{ $t('lang.bookings.aside_text_2') }}</p>
                </div>
              </div>
              <h6 class="filters_col_h6">
                {{ $tc('lang.bookings.aside_text_bottom', 1) }}
                <a
                  :href="`/${this.$store.state.main.lang}/full-help`"
                  target="_blank"
                >{{ $tc('lang.bookings.aside_text_bottom', 2) }}</a>
              </h6>
            </div>
          </aside>

          <!-- /aside -->

          <div class="col-lg-9">
            <div
              class="category_filter"
              style="margin-bottom: 0px"
            >
              <label class="container_radio">{{ $t('lang.bookings.filters_all') }}
                <input
                  id="all"
                  v-model="bookingsFilter"
                  type="radio"
                  value="all"
                  name="bookings_filter"
                  class="selected"
                >
                <span class="checkmark" />
              </label>
              <label class="container_radio">{{ $t('lang.bookings.filters_pending') }}
                <input
                  id="pending"
                  v-model="bookingsFilter"
                  type="radio"
                  value="pending"
                  name="bookings_filter"
                >
                <span class="checkmark" />
              </label>
              <label class="container_radio">{{ $t('lang.bookings.filters_closed') }}
                <input
                  id="closed"
                  v-model="bookingsFilter"
                  type="radio"
                  value="closed"
                  name="bookings_filter"
                >
                <span class="checkmark" />
              </label>
            </div>

            <TransferBookingCard
              v-for="(booking, index) in transfers"
              :key="'transfer'+index"
              :booking="booking"
            />

            <BookingCard
              v-for="(booking, index) in bookings"
              :key="'booking'+index"
              :booking="booking"
              @selectedBookingCard="clickBooking"
            />
            <Errors
              v-if="transfers.length===0 && bookings.length===0"
              :errors="listErrors"
            />
          </div>
        </div>
      </div>
    </main>

    <FooterComponent />
  </div>
</template>

<script>
import TransferBookingCard from '@/components/Transfer/TransferBookingCard';
import Success from '@/components/Alerts/Success';
import NavBar from '../components/NavBar/NavBar';
import Errors from '../components/Alerts/Errors';
import BookingCard from '../components/Booking/BookingCard';
import FooterComponent from '../components/FooterComponent';

import { API, errorResponse } from '../api/api';

const BookingAPI = API.get('booking');
const TransferAPI = API.get('transfer');

export default {
  name: 'Bookings',

  components: {
    Success,
    TransferBookingCard,
    NavBar,
    Errors,
    BookingCard,
    FooterComponent,
  },

  data() {
    return {
      errors: {},
      successMessage: null,
      bookingsList: [],
      transferBookings: [],
      showData: false,
      bookingsFilter: 'all',
      listErrors: { results_error: [this.$t('lang.bookings.no_results')] },
      date: new Date().toISOString(),
      selectedBooking: [],
    };
  },
  computed: {
    transfers() {
      const filter = this.bookingsFilter;
      const list = [];
      const now = new Date();

      this.transferBookings.forEach((booking) => {
        const status = booking.transfer_booking_status;
        const transferDate = new Date(booking.date_time);

        if (status === 'confirmed') {
          if (filter === 'all') {
            list.push(booking);
          }
          if (filter === 'closed' && transferDate < now) {
            list.push(booking);
          }
          if (filter === 'pending' && transferDate >= now) {
            list.push(booking);
          }
        }
      });

      return list;
    },
    bookings() {
      const filter = this.bookingsFilter;
      const list = [];

      this.bookingsList.forEach((booking) => {
        const status = booking.booking_status;

        if (filter === 'all') {
          list.push(booking);
        }
        if (filter === 'closed' && (status === 'closed' || status === 'cancelled')) {
          list.push(booking);
        }
        if (filter === 'pending' && status !== 'closed' && status !== 'cancelled') {
          list.push(booking);
        }
      });

      return list;
    },
  },

  async beforeCreate() {
    try {
      const { data } = await BookingAPI.getBookings();
      if (data.length) {
        this.bookingsList = data;
      }
      this.showData = true;

      const transferData = await TransferAPI.getTransferBookings();
      if (transferData.data.length) {
        this.transferBookings = transferData.data;
      }
    } catch (error) {
      this.errors = errorResponse(error);
      this.showData = false;
      if (error.response.status === 401) {
        await this.$store.dispatch('setAuthToShow', 'login');
        this.$root.$emit('bv::show::modal', 'authModal');
        // GTAG Event
        dataLayer.push({
          event: 'open_auth_modal',
          source: 'bookings',
        });
      }
    }
    const { query } = this.$route;
    if (query.payment) {
      if (query.payment === 'success') {
        this.successMessage = this.$t('lang.bookings.payment_success');
      } else if (query.payment === 'error') {
        this.errors = { payment_error: [this.$t('lang.bookings.payment_error')] };
      }
    }
  },

  methods: {
    clickBooking(booking) {
      this.selectedBooking = booking;
      this.$router.push(`/bookings/${booking.id}`);
    },

    closeDetail() {
      this.selectedBooking = [];
    },
  },
};
</script>
